import React, { useEffect, useState } from "react";

const CreateContractPoste = ({ contract, setContract, qualifications }) => {
  const [isEditTauxHoraire, setIsEditTauxHoraire] = useState(false);
  useEffect(() => {
    if (contract.clientQualification) return;
    setContract({
      ...contract,
      isEditTauxHoraire: false,
      clientQualification: {
        IdQualification: "JDDJJD",
        TxtQualification: "Developpeur FullStack",
      },
    });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="flex flex-col h-full justify-between">
      <div>
        <p className="text-sm font-semibold text-left text-slate-900">Poste</p>

        <div className="flex flex-col max-h-48 items-start my-3 overflow-y-auto space-y-3">
          {qualifications.map((qualification, idx) => {
            return (
              <div
                className={`${
                  contract?.clientQualification?.IdQualification ===
                    qualification?.IdQualification &&
                  contract?.clientQualification?.Niveau ===
                    qualification?.Niveau
                    ? "bg-blue-50 text-blue-800"
                    : ""
                } p-2 w-full `}
                onClick={() =>
                  setContract({
                    ...contract,
                    clientQualification: qualification,
                  })
                }
                key={idx}
              >
                <p className="font-semibold">{qualification.IdQualification}</p>
                <p>{qualification.TxtQualification}</p>
                <p className="">Coefficient : {qualification.CoeffHeures}</p>
                {qualification.Niveau !== "" && (
                  <p>Niveau {qualification.Niveau}</p>
                )}
                {qualification.Niveau === "" && <p>Niveau N/C</p>}
                <p>{qualification.PCS}</p>
                <p>{qualification.TauxPaye}&euro;/h</p>
              </div>
            );
          })}
        </div>
        <p className="text-center">
          <button
            onClick={() => {
              setIsEditTauxHoraire(!isEditTauxHoraire);
              setContract({
                ...contract,
                isEditTauxHoraire: !isEditTauxHoraire,
              });
            }}
            className="bg-blue-700 text-white rounded-md p-2"
          >
            Editer le taux horaire
          </button>
        </p>

        {isEditTauxHoraire && (
          <div className="mt-3 flex items-center space-x-2 justify-center">
            <input
              onChange={(e) => {
                setContract({ ...contract, coefficient: e.target.value });
              }}
              className="border border-gray-300 rounded-md p-2 outline-none"
              placeholder="Coefficient"
            />
            <input
              onChange={(e) => {
                setContract({ ...contract, tauxHoraire: e.target.value });
              }}
              className="border border-gray-300 rounded-md p-2 outline-none"
              placeholder="Taux horaire"
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default CreateContractPoste;
